<template>
    <el-dialog
        :visible="showDialogMassive"
        @open="initForm"
        @close="close"
    >
        <template slot="title">
            <h4>
                Enviar masivamente
                <el-tooltip content="Al enviar masivamente a más de 10 sitemas, será enviadas por segundo plano (colas)"
                    effect="dark" placement="top"
                >
                    <i class="fa fa-info-circle"></i>
                </el-tooltip>
            </h4>
        </template>
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label class="control-label">
                        Notificación
                    </label>
                    <el-select v-model="data.notification_id" placeholder="">
                        <el-option v-for="(notification, index) in notifications"
                            :key="index"
                            :label="notification.title"
                            :value="notification.id"
                        ></el-option>
                    </el-select>
                </div>
            </div>
            <div class="col-12 mt-3">
                <el-upload
                    ref="upload"
                    accept=".xlsx, .xls"
                    :data="data"
                    class="upload-demo"
                    action="/notifications/massive-by-excel"
                    :headers="uploadHeaders"
                    :on-progress="handleProgress"
                    :on-success="handleSuccess"
                    :before-remove="handleRemove"
                    :multiple="false"
                    :limit="1"
                >
                    <el-button size="small"
                        type="primary"
                    >
                        Seleccionar un archivo (xlsx)
                    </el-button>
                </el-upload>
            </div>
            <div class="col-12 mt-4 mb-2">
                <a class="text-dark mr-auto" href="/formats/notificaciones_masivo.xlsx" target="_new">
                    <span class="mr-2">Descargar formato de ejemplo para importar</span>
                    <i class="fa fa-download"></i>
                </a>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click.prevent="close"
                size="small"
            >
                Cancelar
            </el-button>
            <el-button type="primary"
                @click.prevent="submit"
                size="small"
            >
                Procesar
            </el-button>
        </span>
    </el-dialog>
</template>

<script>
    export default {
        name: 'ModalMassive',
        props: {
            showDialogMassive: {
                type: Boolean,
                default: false
            },
            notifications: {
                type: Array,
                default: () => []
            }
        },
        data() {
            return {
                uploadHeaders: {
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                data: {
                    hostnames: null,
                    notification_id: null,
                    message: null,
                    title: null
                }
            }
        },
        methods: {
            close() {
                this.$emit('update:showDialogMassive', false)
                this.$refs.upload.clearFiles()
                this.initForm()
            },
            handleProgress(event, file , fileList) {
                this.loading = this.$loading({
                    lock: true,
                    text: 'Se está procesando la información, por favor espere.',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
            },

            handleSuccess(response, files, fileList) {
                console.log(response)
                if (response.success) {
                    this.data.hostnames = response.data.list_hostname
                    const missing_hostname = response.data.missing_hostname || []
                    if (missing_hostname.length) {
                        const message = `<span>Los siguientes hostnames no fueron encontrados:</span><br>
                            <span>${missing_hostname.join(', ')}</span>
                        `
                        this.$message.error({
                            dangerouslyUseHTMLString: true,
                            message
                        })
                        setTimeout(() => {
                            this.$message.success(response.message)
                        }, 2000)
                    } else {
                        this.$message.success(response.message)
                    }
                } else {
                    this.$message.error(response.message)
                }
                this.loading.close()
            },

            handleRemove(file, fileList) {
                this.data.hostnames = null
            },

            initForm() {
                this.data = {
                    hostnames: null,
                    notification_id: null,
                    message: null,
                    title: null
                }
            },

            submit() {
                const missingNotification = this.data.notification_id === null || this.data.notification_id === null || this.data.notification_id === null
                const missingFile = this.data.hostnames === null
                if (missingNotification) {
                    this.$message.error('Debe seleccionar una notificación')
                    return
                }
                if (missingFile) {
                    this.$message.error('Debe seleccionar un archivo')
                    return
                }
                const notification = this.notifications.find(notification => notification.id === this.data.notification_id)
                if (notification) {
                    this.data.message = notification.message
                    this.data.title = notification.title
                }
                this.$emit('submit-from-excel', this.data)
                this.close()
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/notifications/partials/ModalMassive.vue